<template>
  <v-snackbar
    v-model="show"
    :bottom="true"
    :right="true"
    :timeout="3000"
  >
    {{ snacktext }}
    <v-btn color="pink" @click="closeBar">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "TheSnackBar",
  data() {
    return {
      show: false
    };
  },
  computed: mapState(["snacktext"]),
  methods: {
    closeBar() {
      this.show = false;
    }
  },
  created() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'setText') {
        this.show = true;
      }
    })
  }
};
</script>
